import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PackageScheduleSearchViewComponent } from './package-schedule-search-view/package-schedule-search-view.component';  
import { NewPackageScheduleComponent } from './new-package-schedule/new-package-schedule.component';
@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'list',
        loadChildren: () => import('./package-schedule-search-view/package-schedule-search-view.module').then(m => m.PackageScheduleSearchViewModule) 
      },
      {
        path: 'create',
        loadChildren: () => import('./new-package-schedule/new-package-schedule.module').then(m => m.NewPackageScheduleModule)
      } 
    ])
  ],
  providers: []
})
export class PackageModule { }
